import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const About = () => {
  return (
    <div>
      <Navbar />
      <section className="in_page p70 bg4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <h1 className="hadding">About Us</h1>
              <p>
                Dyntech is the next-generation trading technology and service
                provider, dedicated to powering and growing institutional
                trading businesses worldwide. From turnkey stock/FX brokerages
                to full-stack cryptocurrency exchanges, we blend cutting-edge
                platform engineering with deep market expertise to help you
                scale, innovate, and lead.
              </p>
            </div>
            <div className="col-md-4 m-auto">
              <img
                src="/img/about-us.png"
                alt="about us"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="in_page p70 bg2">
        <div className="container">
          <h2 className="hadding">Our Mission</h2>
          <p>
            At Dyntech, our mission is to empower professional and institutional
            clients with robust, secure, and highly customizable trading
            infrastructures. We strive to:
          </p>
          <ul className="list">
            <li>
              <b>Innovate Continually:</b> Develop future-proof technology that
              adapts to evolving markets.
            </li>
            <li>
              <b>Deliver Excellence:</b> Uphold the highest standards of
              reliability, performance, and security.
            </li>
            <li>
              <b>Enable Growth:</b> Provide end-to-end advisory and support to
              accelerate client success.
            </li>
          </ul>
          <h2 className="hadding mt-4 mt-md-5">Our Vision</h2>
          <p>
            We envision a world where seamless, transparent, and intelligent
            trading solutions unlock new opportunities for financial
            institutions, asset managers, and fintech pioneers. By fostering
            collaboration and leveraging emerging technologies - like AI-driven
            analytics and blockchain - we aim to shape the future of finance.
          </p>
      
          <h2 className="hadding mt-4 mt-md-5">Our Team</h2>
          <p>Our multidisciplinary team brings together experts in:</p>
          <div className="table-responsive mb-5">
          <table className="table ">
            <tr>
              <th>Discipline</th>
              <th>Expertise</th>
            </tr>
            <tr>
              <td>Software Engineering</td>
              <td>Scalable, low-latency platform architecture</td>
            </tr>
            <tr>
              <td>Quantitative Analysis</td>
              <td>Market modeling, algorithmic strategies </td>
            </tr>
            <tr>
              <td>Blockchain Development</td>
              <td>Smart contracts, DeFi, exchange integrations</td>
            </tr>
            <tr>
              <td>Compliance & Risk</td>
              <td>KYC/AML, regulatory liaison, risk frameworks</td>
            </tr>
            <tr>
              <td>Customer Success</td>
              <td>Onboarding, training, dedicated support</td>
            </tr>
          </table> </div>
          <p>
            Together, we’re committed to delivering not just software, but
            long-term partnerships built on trust and results.
          </p>
       
        </div>
      </section>
      <section className="in_page startrader_section  p70 bg4">
        <div className="container">
          <h2 className="hadding">Why Dyntech?</h2>
          <div className="row pt-md-3">
            <div className="col-md-6 mb-4">
             <i className="bi bi-card-checklist"></i>
              <h5 className="trade_item_subtitle">
               Proven Track Record
              </h5>
              <p> 50+ platforms launched; over $200 billion in cumulative transaction volume.</p>
            </div>
            <div className="col-md-6 mb-4">
              <i className="bi bi-globe"></i>
              <h5 className="trade_item_subtitle"> Global Footprint</h5>
              <p>
               Clients across North America, EMEA, and APAC.  </p>
            </div>
            <div className="col-md-6 mb-4 ">
             <i className="bi bi-boxes"></i>
              <h5 className="trade_item_subtitle">
                Modular Architecture
              </h5>
              <p>
                Pick and choose components -matching your business model and scale.
              </p>
            </div>
            <div className="col-md-6 mb-4 mb-md-0">
             <i class="bi bi-headphones"></i>

              <h5 className="trade_item_subtitle">24/7 Support</h5>
              <p> Real-time monitoring and round-the-clock engineering assistance.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
